import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="animate-fade-in">
      {/* Hero Section */}
      <section className="relative min-h-[85vh] flex items-center bg-oya-black overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/header.jpg"
            alt="Atelier réparation smartphone OYA PHONE"
            className="w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-oya-black via-oya-black/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-b from-oya-red/5 via-transparent to-oya-black/30" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-32 md:py-40 w-full">
          <div className="max-w-2xl">
            <div className="inline-block px-4 py-1.5 bg-oya-red/20 rounded-full mb-6 animate-slide-down">
              <span className="text-oya-red-light text-sm font-medium">Réparation & Accessoires — Landunvez</span>
            </div>
            <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 animate-slide-up">
              OYA PHONE
            </h1>
            <p className="text-lg md:text-xl text-white/80 mb-8 max-w-lg leading-relaxed animate-slide-up" style={{ animationDelay: "0.1s" }}>
              Réparation smartphone, tablette et console. Une sélection d'accessoires recommandés pour protéger et optimiser vos appareils.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4 animate-slide-up" style={{ animationDelay: "0.2s" }}>
              <a
                href="tel:0651004790"
                className="inline-flex items-center gap-2 px-8 py-4 bg-oya-red text-white font-medium rounded-full hover:bg-oya-red-dark transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                Prendre rendez-vous
              </a>
              <Link
                to="/accessoires"
                className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/30 text-white font-medium rounded-full hover:bg-white hover:text-oya-black transition-colors whitespace-nowrap"
              >
                <i className="ri-shopping-bag-line" />
                Voir les accessoires
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-4 md:left-8 right-4 md:right-8">
          <p className="text-white/40 text-xs md:text-sm font-medium tracking-widest uppercase">
            Uniquement sur rendez-vous — Mardi au Samedi
          </p>
        </div>
      </section>

      {/* Services Quick Access */}
      <section className="py-20 md:py-28 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14 md:mb-20">
            <h2 className="text-2xl md:text-4xl font-bold text-oya-black mb-4">Les services proposés</h2>
            <p className="text-oya-gray-medium max-w-xl mx-auto">
              Du remplacement d'écran à la désoxydation, OYA PHONE intervient sur tous types de pannes mobile.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {[
              { icon: "ri-smartphone-line", title: "Écran", desc: "Remplacement écran cassé ou tactile" },
              { icon: "ri-battery-line", title: "Batterie", desc: "Batterie usée ou gonflée" },
              { icon: "ri-plug-line", title: "Connecteur", desc: "Port de charge défectueux" },
              { icon: "ri-mic-line", title: "Audio", desc: "Micro et haut-parleur" },
              { icon: "ri-camera-line", title: "Caméra", desc: "Caméra avant et arrière" },
              { icon: "ri-drop-line", title: "Désoxydation", desc: "Nettoyage après eau" },
            ].map((service) => (
              <Link
                key={service.title}
                to="/reparation"
                className="group flex items-start gap-4 p-5 md:p-6 rounded-xl bg-oya-cream hover:bg-oya-black transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-oya-red/10 group-hover:bg-oya-red/20 transition-colors shrink-0">
                  <i className={`${service.icon} text-oya-red text-lg`} />
                </div>
                <div>
                  <h3 className="text-base font-bold text-oya-black group-hover:text-white transition-colors mb-1">
                    {service.title}
                  </h3>
                  <p className="text-sm text-oya-gray-medium group-hover:text-white/60 transition-colors">
                    {service.desc}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Accessories Preview */}
      <section className="py-20 md:py-28 px-4 bg-oya-black">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
            <div>
              <div className="inline-block px-4 py-1.5 bg-oya-red/20 rounded-full mb-4">
                <span className="text-oya-red-light text-sm font-medium">Accessoires recommandés</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-white">
                Protégez votre smartphone
              </h2>
            </div>
            <Link
              to="/accessoires"
              className="inline-flex items-center gap-2 text-white font-medium hover:text-oya-red transition-colors whitespace-nowrap"
            >
              Voir tous les accessoires
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              { img: "https://readdy.ai/api/search-image?query=Premium%20clear%20silicone%20phone%20case%20on%20white%20background%20product%20photography%20minimalist%20high%20quality&width=300&height=300&seq=acc1&orientation=squarish", title: "Coques & Housses" },
              { img: "https://readdy.ai/api/search-image?query=Premium%20tempered%20glass%20screen%20protector%20packaging%20on%20white%20background%20product%20photography%20minimalist%20high%20quality&width=300&height=300&seq=acc2&orientation=squarish", title: "Protections écran" },
              { img: "https://readdy.ai/api/search-image?query=Modern%20USB-C%20fast%20charger%20white%20wall%20adapter%20on%20white%20background%20product%20photography%20minimalist%20high%20quality&width=300&height=300&seq=acc3&orientation=squarish", title: "Chargeurs rapides" },
              { img: "https://readdy.ai/api/search-image?query=Premium%20braided%20USB-C%20cable%20black%20on%20white%20background%20product%20photography%20minimalist%20high%20quality&width=300&height=300&seq=acc4&orientation=squarish", title: "Câbles & Connectique" },
            ].map((item) => (
              <Link
                key={item.title}
                to="/accessoires"
                className="group block rounded-xl overflow-hidden bg-oya-cream hover:bg-oya-black-soft transition-all duration-300"
              >
                <div className="aspect-square bg-white p-6 flex items-center justify-center">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-oya-black group-hover:text-white transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-oya-gray-medium group-hover:text-white/60 transition-colors mt-1">
                    Voir les offres
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 md:py-28 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
            <div>
              <h2 className="text-2xl md:text-4xl font-bold text-oya-black mb-6 leading-tight">
                Pourquoi choisir OYA PHONE ?
              </h2>
              <div className="space-y-5">
                {[
                  { icon: "ri-map-pin-line", title: "Local & accessible", desc: "Situé à Landunvez, au cœur du Finistère. Interventions uniquement sur rendez-vous pour un service personnalisé." },
                  { icon: "ri-tools-line", title: "Savoir-faire technique", desc: "Réparation de smartphones, tablettes et consoles de jeux avec des pièces de qualité et un soin attentif." },
                  { icon: "ri-shield-check-line", title: "Conseils & accessoires", desc: "Sélection d'accessoires testés et approuvés : coques, protections écran, chargeurs et plus encore." },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-oya-red/10 shrink-0">
                      <i className={`${item.icon} text-oya-red text-lg`} />
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-oya-black mb-1">{item.title}</h3>
                      <p className="text-sm text-oya-gray-medium leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="/images/reparation-smartphone.jpg"
                alt="Atelier OYA PHONE"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 md:py-28 px-4 bg-oya-cream">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-oya-black mb-4">
            Prêt à faire réparer votre appareil ?
          </h2>
          <p className="text-oya-gray-medium mb-10 max-w-lg mx-auto">
            OYA PHONE vous accueille du mardi au samedi, uniquement sur rendez-vous à Landunvez.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:0651004790"
              className="inline-flex items-center gap-2 px-8 py-4 bg-oya-red text-white font-medium rounded-full hover:bg-oya-red-dark transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Appeler OYA PHONE
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-oya-black text-oya-black font-medium rounded-full hover:bg-oya-black hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="ri-map-pin-line" />
              Voir l'itinéraire
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}